"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get FILE_PART_SIZE () {
        return FILE_PART_SIZE;
    },
    get getReadStreamAsBase64 () {
        return getReadStreamAsBase64;
    },
    get getReadStreamAsUTF8 () {
        return getReadStreamAsUTF8;
    },
    get isImage () {
        return isImage;
    },
    get isVideo () {
        return isVideo;
    },
    get splitFileIntoParts () {
        return splitFileIntoParts;
    }
});
const _constants = require("../constants");
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
const getReadStream = ({ stream, encoding })=>_async_to_generator(function*() {
        const chunks = [];
        return new Promise((resolve, reject)=>{
            stream.on("data", (chunk)=>chunks.push(Buffer.from(chunk)));
            stream.on("error", (err)=>reject(err));
            stream.on("end", ()=>resolve(Buffer.concat(chunks).toString(encoding)));
        });
    })();
const getReadStreamAsBase64 = (stream)=>_async_to_generator(function*() {
        return getReadStream({
            stream,
            encoding: "base64"
        });
    })();
const getReadStreamAsUTF8 = (stream)=>_async_to_generator(function*() {
        return getReadStream({
            stream,
            encoding: "utf8"
        });
    })();
const isImage = (mimeType)=>!!mimeType && _constants.IMAGE_MIME_TYPES.includes(mimeType);
const isVideo = (mimeType)=>!!mimeType && _constants.VIDEO_MIME_TYPES.includes(mimeType);
const FILE_PART_SIZE = 1024 * 1024 * 100; // 100MB
const splitFileIntoParts = ({ fileSize, partSize = FILE_PART_SIZE })=>{
    return {
        fileSize,
        partSize,
        numParts: Math.ceil(fileSize / partSize)
    };
};

//# sourceMappingURL=data:application/json;base64,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